import "isomorphic-fetch"
const APP_WORKSPACE_URL = String(process.env.REACT_APP_WORKSPACE_URL);
const LOGIN_APP = "hub-app";
const PLATFORM ="excel";

export const refreshTokenService = async (refreshToken: string) => {
  const fullUrl = APP_WORKSPACE_URL + "/auth/refreshToken?platform=excel";

  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${refreshToken}`,
    },
    body: JSON.stringify({ username: "", password: "" }),
  };

  try {
    const resp = await fetch(fullUrl, options);
    return resp;
  } catch (error) {
    throw error;
  }
};

const getToken = async (email: string, password: string) => {
  const fullUrl = `${APP_WORKSPACE_URL}/auth/login?platform=excel&app=${LOGIN_APP}`;

  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username: email, password }),
  };

  try {
    const resp = await fetch(fullUrl, options);
    return resp;
  } catch (error) {
    throw error;
  }
};

export const loginService = async (email: string, password: string) => {
  try {
    const resp = await getToken(email, btoa(password));
    return resp;
  } catch (error) {
    throw error;
  }
};
